import React from 'react';
import { parseRenderOptions } from './utils';
import { FieldWrapper } from './FieldWrapper';
import classNames from 'classnames';
import { Icon } from '../Icon';

/******************************************************************************
 * Single Field
 ******************************************************************************/

export const LinkField = props => {
  const renderOptions = parseRenderOptions(props, { isFloating: false });
  return (
    <FieldWrapper {...props} renderOptions={renderOptions}>
      <div className="field-floating">
        <input
          ref={props.focusRef}
          className={classNames('form-control', renderOptions.fieldClassName, {
            'form-control-sm': renderOptions.size === 'sm',
            'is-invalid': renderOptions.hasErrors,
            'has-btn': !!props.value,
            'is-empty': !props.value,
          })}
          type="text"
          id={props.id}
          name={props.name}
          value={props.value}
          onBlur={props.onBlur}
          onChange={props.onChange}
          onFocus={props.onFocus}
          placeholder={renderOptions.placeholder}
          disabled={!props.enabled}
          form={props.form}
        />
        {!!props.value && (
          <a
            href={props.value}
            type="button"
            className={classNames('btn btn-link-primary btn-floating', {
              'btn-sm': renderOptions.size === 'sm',
            })}
            aria-label="Open Link"
            title="Open Link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon
              name="external-link"
              md={renderOptions.size !== 'sm'}
              sm={renderOptions.size === 'sm'}
            />
          </a>
        )}
      </div>
    </FieldWrapper>
  );
};
